import React from 'react';

import AIMessage from '@/features/ai-chat/components/AskGXDrawer/Messages/AIMessage/AIMessage';
import HumanMessage from '@/features/ai-chat/components/AskGXDrawer/Messages/HumanMessage/HumanMessage';
import isAiMessage from '@/features/ai-chat/lib/isAiMessage';
import isHumanMessage from '@/features/ai-chat/lib/isHumanMessage';
import { useChatState } from '@/features/ai-chat/state/useChat';
import type { Message } from '@/features/ai-chat/types/chat.types';

const MessageComponent = ({ msg, index }: { msg: Message; index: number }) => {
  const { isSending, version, messages } = useChatState();

  const isAI = isAiMessage(msg);
  const isLastMessage = index === messages.length - 1;

  const prevMessage = messages.at(index - 1);
  const prompt = isHumanMessage(prevMessage) ? prevMessage.text : '';

  if (isAI) {
    return (
      <AIMessage
        isLastMessage={isLastMessage}
        isSending={isSending}
        msg={msg}
        prompt={prompt}
        version={version}
      />
    );
  }
  return <HumanMessage msg={msg} />;
};
export default MessageComponent;
